import getQueryList from './getQueryList';

export default function checkIsVariantShownInQuery(variantReference, query) {
  if (!query.show_variants) return false;

  return getQueryList(query.show_variants).includes(variantReference);
}
